import { _notNil } from '@/littledash';
import type { SendBundleValidationResult } from '@/model/Agent.model';
import type { FC } from 'react';
import SendOmissionNotice from './SendOmissionNotice';
import { aiUseLabelOf, omissionOf } from './sendReport';
import SendRuleChecks from './SendRuleChecks';

// Chip's blue and gray schemes, as the source badge draws them, so the label sits at the same weight.
const aiUseColour = {
  without_ai: 'blue b--lightest-blue bg-lightest-blue',
  with_ai: 'near-black b--moon-gray bg-moon-gray',
} as const;

interface SendReportOverviewProps {
  result: SendBundleValidationResult;
  testId?: string;
}

/**
 * The top of a SEND bundle report: whether Benchling In Vivo AI took part, the whole-report omission
 * (the per-file and cross-domain sections announce their own), and how the upload fared against the
 * published SEND rules.
 */
const SendReportOverview: FC<SendReportOverviewProps> = ({ result, testId = 'invivo-send-validator__overview' }) => {
  const aiUse = aiUseLabelOf(result.run_metadata);
  return (
    <div className="ui-card pa4 mb3" data-test-component="SendReportOverview" data-testid={testId}>
      {_notNil(aiUse) && (
        <div className="mb2" data-test-element="ai-use" data-test-key={aiUse.key}>
          <span className={`f7 lh-title dib br2 ba ph2 pv1 ${aiUseColour[aiUse.key]}`}>{aiUse.text}</span>
        </div>
      )}
      <SendOmissionNotice
        omission={omissionOf(result.report.summary, result.report.advisory_counts)}
        testId="invivo-send-validator__report-omission"
      />
      <SendRuleChecks report={result.report} tally={result.report.tally} />
    </div>
  );
};

export default SendReportOverview;
